import { Theme, createTheme as muiTheme } from '@mui/material/styles';

import { colorSchemes } from './color-schemes';
import { components } from './components/components';
import { shadows } from './shadows';
import { typography } from './typography';

import type { Direction } from './types';

interface Config {
  primaryColor: string;
  direction?: Direction;
}

export function createTheme(config: Config): Theme {
  const theme = muiTheme({
    breakpoints: {
      values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1440, max: 1680 },
    },
    colorSchemes: colorSchemes({ primaryColor: config.primaryColor }),
    components,
    direction: config.direction,

    shadows: shadows,

    shape: { borderRadius: 8 },
    typography,
    cssVariables: {
      colorSchemeSelector: 'class',
    },
  });

  return theme;
}
